module.exports = __webpack_public_path__ + "img/balsa-leaf.6fc4f5ab.svg";